import store from '@/store.js'

const TheContainerFluid = () => import('@/containers/TheContainerFluid')
const TheContainer = () => import('@/containers/TheContainer')
const TheMainSidebar = () => import('@/containers/TheMainSidebar') //barra esq
const TheMainAsideBar = () => import('@/containers/TheMainAsideBar') //barra dir
const TheMainSidebarAndAsidebar = () => import('@/containers/TheMainSidebarAndAsidebar') // ambas as barras

const ManageBalance = () => import('./pages/ManageBalance')
const ManageBalanceSteps = () => import('./pages/ManageBalanceSteps')

const balanceRoutes = [
  {
    path: 'balance',
    component: TheContainerFluid,
    children: [
      {
        path: 'manage-balance',
        name: 'manage-balance',
        component: ManageBalanceSteps,
        meta: { requiresAuth: true },
      },
      // {
      //   path: '/balance',
      //   component: TheMainAsideBar,
      //   meta: { requiresAuth: true },
      //   props: { default: true, AsidebarComponente: '' },
      //   children: [
      //     {
      //       path: '/manage-balance',
      //       name: 'manage-balance',
      //       component: ManageBalance,
      //       meta: { requiresAuth: true },
      //     },
      //   ],
      // },
    ],
  },
]

export default balanceRoutes
